'use strict';

(function ($window, $remove, $map, $each, postMsg, moveCarousel, getCarousels, initialiseCarousel) {
    return $each(['initialise-card-carousel', 'resize'], function ($event) {
        return $window.addEventListener($event, function () {
            return initialiseCarousel(getCarousels($map, window, document), $each, moveCarousel, $window, postMsg, $remove);
        });
    });
})(window, function (arr) {
    if (arr.hasOwnProperty('remove')) {
        return Element.prototype.remove.call(arr);
    }
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
    return Element.prototype.remove.call(arr);
}, function (arr, func) {
    return Array.prototype.map.call(arr, func);
}, function (arr, func) {
    return Array.prototype.forEach.call(arr, func);
},
//postMsg
function (carousel) {
    window.postMessage({
        name: 'CARD_CAROUSEL_SHIFTED',
        carousel: {
            carousel: carousel.carousel.classList.toString(),
            shifts: carousel.shifts,
            numOfCards: carousel.numOfCards
        }
    }, '*');
},
//moveCarousel
function (carousel, amount, $each, indicatorElems, postMsg) {
    postMsg(carousel);
    $each(indicatorElems, function (elem) {
        return elem.classList.remove('selected');
    });
    if (indicatorElems.length > 0) indicatorElems[carousel.shifts].classList.add('selected');
    carousel.slider.style.transform = 'translateX(-' + (amount > carousel.endShift ? carousel.endShift : amount) + 'px)';
},
//getCarousels
function ($map, $window, $document) {
    if ($document === undefined) return;
    return $map($document.querySelectorAll('[card-carousel]'), function (carousel) {
        var slider = carousel.querySelector('[carousel-slider]');
        var cards = slider.children;
        var card = cards[0];

        if (card != undefined) {
            var cardMargin = parseInt($window.getComputedStyle(card).marginRight.replace('px', ''), 10);
            var cardSize = card.getBoundingClientRect().width + cardMargin;

            return {
                carousel: carousel,
                slider: slider,
                previousFAB: carousel.querySelector('[nav-button=prev]'),
                nextFAB: carousel.querySelector('[nav-button=next]'),
                indicators: carousel.querySelector('[indicators]'),
                hideCard: carousel.querySelector('[card-hide-card]'),
                cardWidth: card.getBoundingClientRect().width + cardMargin,
                numOfCards: cards.length,
                shifts: 0,
                maxShifts: cardSize >= slider.clientWidth ? cards.length - 1 : Math.ceil((slider.clientWidth - cards.length * cardSize) * -1 / cardSize),
                endShift: cards.length * cardSize - slider.clientWidth - cardMargin
            };
        }

        return undefined;
    });
},
//initialiseCarousel
function (carousels, $each, moveCarousel, $window, postMsg, $remove) {
    if (carousels !== undefined && carousels.length > 0) {
        $each(carousels, function ($carousel) {
            if ($carousel != undefined) {
                var indicatorElems = [];
                var cardContainerWidth = $carousel.cardWidth * $carousel.numOfCards;
                var standardCarouselMove = function standardCarouselMove() {
                    return moveCarousel($carousel, $carousel.cardWidth * $carousel.shifts, $each, indicatorElems, postMsg);
                };
                var displayControls = function displayControls() {
                    if ($carousel.numOfCards == 1) {
                        $carousel.carousel.classList.add('no-carousel-mode');
                    }
                };
                var linkIndicators = function linkIndicators() {
                    if ($carousel.indicators != undefined) {
                        $carousel.indicators.innerHTML = '';
                        $each(indicatorElems, function (indicatorElem, index) {
                            $carousel.indicators.appendChild(indicatorElem);
                            indicatorElem.addEventListener('click', function () {
                                $carousel.shifts = index;
                                standardCarouselMove();
                            });
                        });
                    }
                };

                $carousel.slider.addEventListener('dismiss-card', function (e) {
                    $carousel.numOfCards -= 1;
                    if (indicatorElems.length === 0) return postMsg($carousel);
                    $carousel.shifts -= $carousel.shifts > 0 ? 1 : 0;
                    $carousel.maxShifts -= 1;
                    $remove(indicatorElems[$carousel.shifts]);
                    indicatorElems.splice($carousel.shifts, 1);
                    $carousel.endShift -= $carousel.cardWidth;
                    displayControls();
                    linkIndicators();
                    setTimeout(function () {
                        return standardCarouselMove();
                    });
                });

                if (cardContainerWidth <= $carousel.slider.clientWidth || $carousel.numOfCards === 1) $carousel.carousel.classList.add('no-carousel-mode');else {

                    for (var i = 0; i <= $carousel.maxShifts; i++) {
                        var indicator = document.createElement('div');
                        indicator.classList.add('indicator');
                        indicatorElems.push(indicator);
                    }

                    if (indicatorElems != undefined && indicatorElems.length > 0) {
                        indicatorElems[0].classList.add('selected');
                        linkIndicators();
                    }

                    standardCarouselMove();

                    var shiftNext = function shiftNext() {
                        if ($carousel.shifts >= $carousel.maxShifts) $carousel.shifts = 0;else $carousel.shifts += 1;
                        standardCarouselMove();
                    };

                    var shiftPrevious = function shiftPrevious() {
                        if ($carousel.shifts <= 0) $carousel.shifts = $carousel.maxShifts;else $carousel.shifts -= 1;
                        standardCarouselMove();
                    };

                    // Touch & drag interaction.
                    var startPoint = void 0;
                    $each(['touchstart', 'mousedown'], function (event) {
                        return $carousel.carousel.addEventListener(event, function ($event) {
                            return startPoint = $event.touches !== undefined ? $event.touches[0].pageX : $event.pageX;
                        });
                    });
                    $each(['touchend', 'mouseup'], function (event) {
                        $carousel.carousel.addEventListener(event, function ($event) {
                            var pageX = $event.changedTouches !== undefined ? $event.changedTouches[0].pageX : $event.pageX;
                            var difference = startPoint - pageX;

                            if (difference > 30) {
                                if ($carousel.shifts >= $carousel.maxShifts) $carousel.shifts = 0;else $carousel.shifts += 1;
                            }
                            if (difference < -30) {
                                if ($carousel.shifts <= 0) $carousel.shifts = $carousel.maxShifts;else $carousel.shifts -= 1;
                            }

                            standardCarouselMove();
                        });
                    });

                    // Standard shift buttons (with hold down action.)
                    var interval = void 0;

                    $carousel.nextFAB.addEventListener('mousedown', function () {
                        shiftNext();
                        interval = setInterval(shiftNext, 700);
                    });
                    window.addEventListener('mouseup', function () {
                        return clearInterval(interval);
                    });

                    $carousel.previousFAB.addEventListener('mousedown', function () {
                        shiftPrevious();
                        interval = setInterval(shiftPrevious, 700);
                    });
                    window.addEventListener('mouseup', function () {
                        return clearInterval(interval);
                    });

                    // Hover button.
                    $carousel.nextFAB.addEventListener('mouseover', function () {
                        return moveCarousel($carousel, $carousel.cardWidth * $carousel.shifts + 30, $each, indicatorElems, postMsg);
                    });
                    $carousel.nextFAB.addEventListener('mouseout', function () {
                        return standardCarouselMove();
                    });
                    $carousel.previousFAB.addEventListener('mouseover', function () {
                        return moveCarousel($carousel, $carousel.cardWidth * $carousel.shifts - 30, $each, indicatorElems, postMsg);
                    });
                    $carousel.previousFAB.addEventListener('mouseout', function () {
                        return standardCarouselMove();
                    });
                }
            }
        });
    }
});